import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { bool, string } from 'prop-types'

import * as spacing from 'styles/spacing'
import { white, black } from 'styles/colors'
import { navHeight, animationTime, animationCurve } from 'styles/global'
import { media } from 'styles/media'
import NavLabel from './NavLabel'

const Container = styled.div`
  position: relative;
  margin-right: ${spacing.large};

  ${media.large`
    margin-right: ${spacing.xLarge};
  `};

  ${media.xLarge`
    margin-right: ${spacing.xxLarge};
  `};
`

const NavLink = styled(Link)`
  color: ${props => (props.transparent ? white : black)};
  height: ${navHeight};
  display: flex;
  align-items: center;
  transition: color ${animationTime} ${animationCurve};
`

const NavItem = ({ label, link, transparent, ...rest }) => (
  <Container {...rest}>
    <NavLink to={link} transparent={transparent}>
      <NavLabel>{label}</NavLabel>
    </NavLink>
  </Container>
)

NavItem.propTypes = {
  label: string.isRequired,
  link: string.isRequired,
  transparent: bool
}

export default NavItem
